import Login from "./Login";
import Main from "./Main";
import { useAuth } from "./auth";
import Navigation from "./components/Navigation";
import { backend_url } from "./constants";
import { ToastContainer } from 'react-toastify';
function App() {
  const { isAuthenticated, isLoading, logoutOfAccessToken } = useAuth();

  async function logout() {
    await fetch(backend_url + "/api/logout/", {
      method: "POST",
      credentials: "include",
    });

    logoutOfAccessToken();
  }
  if (isLoading) {
    return <div>Loading…</div>;
  }
  const inner_obj = isAuthenticated ? <Main /> : <Login />;
  return (
    <>
      <Navigation isAuthenticated={isAuthenticated} LogoutFunc={logout} />
      {inner_obj}
      <ToastContainer />
    </>
  );
}

export default App;
